<template>
  <div>
    <div class="title_text">
      <div>
        <Icon type="ios-bookmark" size="18" color="#0466dd" />
        <span class="title_text2">在职折线图</span>
      </div>
      <div class="query_box">
        <DatePicker @on-change="month_change" v-model="select_month" format="yyyy/MM/dd" type="daterange" placement="bottom-end" placeholder="选择日期范围" style="width: 200px" />

      </div>
    </div>
    <div class="chart_box">
      <Spin fix v-if="chart_loading"></Spin>
      <div id="entry_line_chart1"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import { http, open_new_page } from "@/utils/http.js";

export default {
  name: "entry_data",
  data() {
    return {
      project_id: "",
      project_name: "",
      chart_loading: false,
      select_month:[new Date(new Date().getTime() - 86400000 * 30), new Date()]
    };
  },
  mounted() {
    console.log(this.select_month)
  },
  methods: {
    month_change(){
        this.get_chart1_data();
    },

    open(project_id, project_name) {
      this.project_id = project_id;
      this.project_name = project_name;

      this.get_chart1_data();
    },

    //生成入职折线图
    create_entry_chart(count_list, title_list) {
      var myChart = echarts.init(document.getElementById("entry_line_chart1"));

      if (myChart) {
        console.log('销毁图实例')
        // 销毁掉原实例
        myChart.dispose();
      }

      var chartDom = document.getElementById("entry_line_chart1");
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        grid: {
          top: "20px",
          left: "1%",
          right: "1%",
          bottom: "2%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: title_list,
        },
        tooltip: {
          trigger: "axis",
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: count_list,
            type: "line",
            smooth: true,
          },
        ],
      };

      option && myChart.setOption(option);
    },

    //获取在职折线数据
    get_chart1_data() {
      var that = this;
      var obj = {
        project_id: this.project_id,
        start_time:this.select_month[0].getTime()/1000,
        end_time:this.select_month[1].getTime()/1000
      };
      this.chart_loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST +
          "/my_project/project_detail/entry_data/in_job_broken_line",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            console.log(res.data.count_list);
            that.create_entry_chart(res.data.count_list, res.data.title_list);
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.chart_loading = false;
        })
        .catch((res) => {
          console.log(res, "请求出错");
          that.chart_loading = false;
        });
    },
  },
};
</script>

<style scoped>
.chart_box {
  position: relative;
  padding: 10px 0px;
  margin: 10px;
  background: #fff;
  border-radius: 5px;
  height: 430px;
}

.title_text2 {
  font-weight: 600;
}

.export_table {
  font-size: 12px;
  color: #0466dd;
  font-weight: 300;
  margin-right: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  letter-spacing: 1px;
}

.title_text {
  margin: 0px 10px 0 10px;
  font-size: 14px;
  color: #333;
  border-bottom: 1px solid #ddd;
  padding: 10px 10px 5px 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  letter-spacing: 2px;
}
#entry_line_chart1 {
  position: relative;
  top: -10px;
  left: -10px;
  width: calc(100% - 20px);
  margin: 20px;
  height: 400px;
}
</style>